import React from "react";
import Button from "components/button/Button";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";

interface IDeleteModal {
  body: React.ReactNode | string;
  onCancel: () => void;
  onDelete?: () => void;
}

const DeleteModal: React.FC<IDeleteModal> = (props) => {
  const { body, onCancel, onDelete } = props;

  return (
    <div>
      <ModalHeader>Konfirmasi Penghapusan</ModalHeader>
      <ModalCloseButton />
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        {" "}
        <div className="flex gap-3">
          <Button
            size="fit"
            children="Batal"
            variant="gray"
            onClick={onCancel}
          />
          <Button
            size="fit"
            children={<span className="text-white">Ya, hapus</span>}
            variant="danger"
            onClick={onDelete}
          />
        </div>
      </ModalFooter>
    </div>
  );
};

export default DeleteModal;
